import React from 'react';

import styles from './styles.module.scss';

export const HDivider = ({ className = '' }: { className?: string }) => (<div className={`${styles.h} ${className}`}/>);

export const VDivider = () => (<div className={styles.v}/>);
